import React from "react";
import { Link } from "react-router-dom"; 
//images
import wordleImg from "../assets/Images/wordle.png";
import hangmanImg from "../assets/Images/hangman.png";
import sudokuImg from "../assets/Images/sudoku.png";
import tictactoeImg from "../assets/Images/tictactoe.png";

const games = [
  { id: "wordle", name: "Wordle", image: wordleImg, path: "/games/wordle" },
  { id: "hangman", name: "Hangman", image: hangmanImg, path: "/games/hangman" },
  { id: "sudoku", name: "Sudoku", image: sudokuImg, path: "/games/sudoku" },
  { id: "tictactoe", name: "Tic Tac Toe", image: tictactoeImg, path: "/games/tictactoe" },
];


const GamesPage: React.FC = () => {
  return (
    <div className="games-grid">
      {games.map((game, index) => (
        <Link key={index} to={game.path} className="game-card">
          <div className="game-image">
            <img src={game.image} alt={game.name} />
          </div>
          <div className="game-title">{game.name}</div>
        </Link>
      ))}
    </div>
  );
};

export default GamesPage;
